module.exports = __webpack_public_path__ + "static/media/icon-location.137ded6e.svg";